import script from "./storageSample.vue?vue&type=script&setup=true&lang=js"
export * from "./storageSample.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__